import { h, Fragment } from 'preact'
import { useState } from 'preact/hooks'
import { IconButton } from './Button.jsx'
import { ArrowDown } from './Icon.jsx'
import classnames from 'classnames'


export function FacetGroup({ title, children }) {
	const [open, setOpen] = useState(true)
	const classes = classnames('facet-group', !open && 'closed')
	return <div class={classes}>
    	{title && <>
    		<div 
	    		class="facet-group__bar" 
	    		onClick={() => setOpen(!open)}
    		>
	    		<span class="facet-group__title">{title}</span>
	    		<IconButton
	    			class="facet-group__button"
		    		type="button"
	    			variant="ghost tag"
	    			size="x-small"
	    			aria-label="Toggle filters" 
	    			icon={ArrowDown}
	    		/>
    		</div>
    	</>}
    	<div class="facet-group__inner">
    		{children}
    	</div>
    </div>
}